import adminApiClient from '../api/adminApiClient'
import apiClient from '../../services/api'
import type {
  OrderSummaryResponse,
  OrderDetailResponse,
  OrderRetryResponse,
  OrderStatus,
  PaginatedResponse,
  FrameResponse,
  YoloDetectionResponse,
  ComponentReport,
} from '../types'

interface OrdersFilter {
  status?: OrderStatus
  mechanicId?: string
  from?: string
  to?: string
  archived?: boolean
  page?: number
  size?: number
}

export async function getOrders(filter?: OrdersFilter): Promise<PaginatedResponse<OrderSummaryResponse>> {
  const { data } = await adminApiClient.get<PaginatedResponse<OrderSummaryResponse>>('/orders', {
    params: filter,
  })
  return data
}

export async function getOrder(orderNumber: string): Promise<OrderDetailResponse> {
  const { data } = await adminApiClient.get<OrderDetailResponse>(`/orders/${orderNumber}`)
  return data
}

export async function updateOrderStatus(orderNumber: string, status: OrderStatus, reason?: string): Promise<void> {
  await adminApiClient.put(`/orders/${orderNumber}/status`, { status, reason })
  console.log(`[INFO] Order status updated — orderNumber: ${orderNumber}, status: ${status}`)
}

export async function retryOrder(orderNumber: string): Promise<OrderRetryResponse> {
  const { data } = await adminApiClient.post<OrderRetryResponse>(`/orders/${orderNumber}/retry`)
  console.log(`[INFO] Order retry triggered — orderNumber: ${orderNumber}, retryCount: ${data.retryCount}`)
  return data
}

export async function archiveOrder(orderNumber: string): Promise<void> {
  await adminApiClient.post(`/orders/${orderNumber}/archive`)
  console.log(`[INFO] Order archived — orderNumber: ${orderNumber}`)
}

export async function getOrderVideoUrl(orderNumber: string): Promise<string> {
  const { data } = await adminApiClient.get<{ url: string }>(`/orders/${orderNumber}/video/url`)
  return data.url
}

export async function getOrderFrames(orderNumber: string): Promise<FrameResponse[]> {
  const { data } = await adminApiClient.get<FrameResponse[]>(`/orders/${orderNumber}/frames`)
  return data
}

export async function getOrderYoloDetections(orderNumber: string): Promise<YoloDetectionResponse[]> {
  const { data } = await adminApiClient.get<YoloDetectionResponse[]>(`/orders/${orderNumber}/yolo-detections`)
  return data
}

export async function getOrderComponentReports(orderId: string): Promise<ComponentReport[]> {
  const { data } = await apiClient.get<{ componentReports: ComponentReport[] }>('/order/getReportDetail', {
    params: { id: orderId },
  })
  return data.componentReports ?? []
}

export async function bulkDeleteOrders(orderNumbers: string[]): Promise<{ deletedCount: number }> {
  const { data } = await adminApiClient.delete<{ deletedCount: number }>('/orders', {
    data: { orderNumbers },
  })
  console.log(`[INFO] Bulk delete orders — requested: ${orderNumbers.length}, deleted: ${data.deletedCount}`)
  return data
}
